import { ofType } from 'redux-observable';
import { Observable, from, of } from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';
import { fetchy } from '@bridebook/web/lib/fetchy';
import {
  AccessControlActionTypes,
  IOnAccessControlListenerAction,
} from '@bridebook/web/lib/access-control/action-types';
import { fetchCollaboratorsEmailsSuccess } from '@bridebook/web/lib/access-control/actions';
import { appError } from '@bridebook/web/lib/app/actions';
import { IEpicDeps } from '@bridebook/web/lib/types';
import { ICollaborator } from '../types';

export const fetchCollaboratorsEmails = (
  action$: Observable<IOnAccessControlListenerAction>,
  { state$ }: IEpicDeps,
) =>
  action$.pipe(
    ofType(AccessControlActionTypes.ON_ACCESS_CONTROL_LISTENER),
    withLatestFrom(state$),
    mergeMap(([{ payload: acl }, state]) => {
      if (!acl) {
        return of();
      }

      const { id: weddingId } = state.weddings.profile;

      const getPromise = async () => {
        const response = await fetchy().authenticated.post(
          '/api/nonces/fetch-collaborators',
          null,
          {
            weddingId,
          },
        );

        return response.collaborators as ICollaborator[];
      };

      return from(getPromise()).pipe(
        mergeMap((collaborators: ICollaborator[]) => {
          if (collaborators) {
            return of(fetchCollaboratorsEmailsSuccess(collaborators));
          }

          return of();
        }),
        catchError((error: Error) => of(appError({ error, feature: 'Access Control' }))),
      );
    }),
    catchError((error: Error) => of(appError({ error, feature: 'Access Control' }))),
  );
